import React, { useState } from "react";
import { Box, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import BaseCard from "../../../components/Cards/Card";
import CustomButton from "../../../components/CustomButton";
import CustomText, { textStyles } from "../../../components/CustomText";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTranslation } from "react-i18next";
import toast, { Toaster } from "react-hot-toast";
import CircularProgress from "@mui/material/CircularProgress";

import verifyface from "../../../assets/verifyface.png";
import profiledone from "../../../assets/profiledone.svg";
import { getProfileDraft, clearProfileDraft } from "./ProfileDraft";
import { BASE_URL } from "../../../components/BaseUrl";

const RegisterationVerification = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isLaptop = useMediaQuery(theme.breakpoints.between("md", "lg"));
  const navigate = useNavigate();
  const [isContinueClicked, setIsContinueClicked] = useState(false);
  
  const { t } = useTranslation();

  const [submitting, setSubmitting] = useState(false);

  const handleContinue = async () => {
    try {
setIsContinueClicked(true)
      setSubmitting(true);

      const draft = getProfileDraft();
      console.log("profile draft", draft)
      if (!draft || !draft.first_name || !draft.legal_name) {
        toast.error("Profile draft incomplete");
        setSubmitting(false);
        return;
      }

      const res = await fetch(`${BASE_URL}/company-admins/setup-complete-profile`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("profileUpdateToken")}`,
        },
        body: JSON.stringify(draft),
      });

      const data = await res.json();
      console.log(data)
      if (!res.ok || data?.error) {
        throw new Error(data?.message || "Failed to verify profile");
      }

      toast.success(data?.message || "Profile verified successfully!");
      clearProfileDraft();

      setTimeout(() => {
        navigate("/admin-approval"); // or "/dashboard"
      }, 1500);
    } catch (err) {
      toast.error(err.message || "Verification failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Box sx={{ py: isMobile ? 5 : 0, px: 2 }}>
      <Toaster />
        <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "100vh",
      px: 2,
  
    }}
  >
      <BaseCard maxWidth={isMobile ? "100%" : isTablet ? "60%" : isLaptop ? "40%" : "30%"}>
        <CustomText
          sx={{
            ...textStyles.h4,
            color: "#172B4D",
            textAlign: "center",
            fontSize: "26px",
            letterSpacing: "0px !important",
          }}
        >
          {t("verificationCompleteTitle")}
        </CustomText>
        <CustomText
          sx={{
            ...textStyles.body5,
            color: "#6B778C",
            pt: 1.2,
            textAlign: "center",
            letterSpacing: "0px !important",
          }}
        >
          {t("verificationCompleteSubtitle")}
        </CustomText>
{/* 
        <Box sx={{ mt: 4, px: 2, display: "flex", justifyContent: "center", alignItems: "center" }}>
          <img src={verifyface} style={{ width: "80%", height: "80%", objectFit: "contain" }} />
        </Box> */}

        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 6, gap: 2 }}>
          <CustomButton
            label={t("back")}
                // disabled={isContinueClicked} 
            variant="text"
            onClick={() => navigate(-1)}
            sx={{ color: "black", px: 0, backgroundColor: "white", height: 20,
                               backgroundColor: isContinueClicked ? "#f0f0f0" : "white", // light grey if disabled
    color: isContinueClicked ? "#999" : "black",
    "&:hover": {
      backgroundColor: isContinueClicked ? "#f0f0f0" : "white",
      color: isContinueClicked ? "#999" : "black",
    },
             }}
          />
          <CustomButton
            label={
              submitting ? (
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <CircularProgress size={18} sx={{ color: "#fff" }} /> {t("continue")}
                </Box>
              ) : (
                t("continue")
              )
            }
            size="medium"
            onClick={handleContinue}
            sx={{ px: 4, height: 20 }}
            disabled={submitting}
          />
        </Box>
      </BaseCard>
      </Box>
    </Box>
  );
};

export default RegisterationVerification;
